<template>
  <div>
    <Header></Header>
    <section>
      <div class="index_table">
        <table>
          <thead>
            <tr>
              <th>Target Proteins<br>靶点ID</th>
              <th>species<br> 物种</th>
              <th>Protein Description<br>蛋白质描述</th>
              <th>Gene Name<br>基因名称</th>
              <th>Probe ID<br>探针ID</th>
              <th>Probe structure<br>探针结构</th>
              <th>Probe type<br>探针类型</th>
              <th>Labeled Sites Detail<br>标记位点</th>
              <th>浓度</th>
              <th>竞争比值(P/PC)</th>
              <th>竞争配体</th>
              <th>细胞系</th>
              <th width="180">实验数据来源</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><router-link to="/description">P56003</router-link></td>
              <td>Helicobacter pylori</td>
              <td></td>
              <td></td>
              <td><router-link to="/probe">LA1509-P01（LA1509-C01）</router-link></td>
              <td><img src="../assets/3.jpg"/></td>
              <td>Photoreactive</td>
              <td><router-link to="/site">Link</router-link></td>
              <td>10uM</td>
              <td>5</td>
              <td>Cp_ID1</td>
              <td>h460</td>
              <td><a href="javascript:void(0)" @click="sourcesOpen()">LA_exp_10001</a></td>
            </tr>
          </tbody>
        </table>
      </div>

    </section>

    <div class="pop_bg" v-show="popBgShow == true"></div>
    <div class="pop_data_sources"  v-show="popSourcesShow == true">
      <div class="header_info">
        <div class="title">数据来源LA_exp_10001</div>
        <a href="javascript:void(0)" class="close_btn" @click="sourcesClose()">×</a>
      </div>
      <h1>内容：</h1>
      <div class="sources_article">
        实验编号： LA_exp_10008<br>
        实验日期：20221228<br>
        实验设计（模板）：本实验使用TMT方法对（细胞系）细胞进行处理，共使用5种竞争化合物处理细胞进行标记，每组3重复，得到的结果和
        混合池进行对比得到每组样品的相对丰度，最终重复组的结果作为某一竞争配体的竞争比值。<br>
        物种和细胞系： X物种Y细胞系（理论上和前面的靶点实验须保持一致）<br>
        竞争配体：（放结构图片），几个化合物放几个结构图<br>
        竞争配体浓度：（浓度值），几个化合物放几个配体浓度
      </div>
    </div>


    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './header/Index.vue'
  import Footer from './footer/Index.vue'
  export default {
    components:{
      Header,
      Footer
    },
     data() {
      return {
        popBgShow:false,
        popSourcesShow:false,
      }
    },
     methods: {
        sourcesOpen(){
          this.popBgShow=true;
          this.popSourcesShow=true;
        },
        sourcesClose(){
          this.popBgShow=false;
          this.popSourcesShow=false;
        }
     }
  }
</script>



// WEBPACK FOOTER //
// src/views/Search.vue